import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface CommonPageLayoutProps {
  children: ReactNode
  className?: string
}

/**
 * Common page layout wrapper that provides consistent backdrop and spacing
 * for all pages (list and detail views).
 *
 * This component ensures that the background color, padding, and overall
 * container dimensions are identical across different page types.
 */
export function CommonPageLayout({
  children,
  className,
}: CommonPageLayoutProps) {
  return (
    <div
      className={cn('flex flex-col', className)}
      style={{
        backgroundColor: 'rgb(245, 245, 245)',
        // Compensar el padding del main padre (py-5 = 2.5rem) y navbar (pt-24/md:pt-16)
        margin: '-1.25rem -1rem -1.25rem -1rem', // -py-5 y -px (sm:px-2 md:px-4 lg:px-8)
        padding: '0 1rem 0 1rem', // Restaurar padding horizontal
        minHeight: 'calc(100vh - 4rem)', // Solo restar navbar
        height: 'calc(100vh - 6rem)',
        width: 'calc(100% + 2rem)', // Compensar el margin negativo horizontal
      }}
    >
      <div className="flex h-full flex-col px-4 py-12 md:px-0 md:py-4 lg:px-0 lg:py-3">
        {children}
      </div>
    </div>
  )
}
